import { React, useContext, useState } from 'react';
import { format } from 'date-fns';
import { Link } from 'react-router-dom';

import AuthContext from '../../../api/AuthProvider';
import axios from '../../../api/axios';
import FeedComments from './FeedComments';

const FeedPost = (props) => {
    const { postContent } = props;
    const { user } = useContext(AuthContext);
    // state to create a comment
    const [comment, setComment] = useState('');
    // state to show and hide comment field
    const [showCommentField, setShowCommentField] = useState(false);
    // state to show and hide comments
    const [showComments, setShowComments] = useState(false);
    // state to show and hide attachments
    const [showAttachments, setShowAttachments] = useState(false);
    // state to display comments on posts
    const [postComments, setPostComments] = useState(
        props.postContent.comments
    );
    // state to display likes on posts
    const [post_likes, setPost_likes] = useState(props.postContent.likers);

    // handles creating a comment
    const handleChange = (e) => {
        setComment(e.target.value);
    };
    // handles liking a post
    const likePost = async () => {
        try {
            const requestBody = {
                content: props.postContent.pk,
            };
            let response = await axios.post(
                '/api/social/like/',
                JSON.stringify(requestBody),
                {
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    withCredentials: true,
                }
            );
            // add or remove user's like from frontend data
            if (response.status === 200) {
                // if user has already liked this post
                if (
                    [
                        post_likes.find((e) => e.username === user.username),
                    ][0] !== undefined
                ) {
                    // remove like from post
                    setPost_likes((filteredLikes) => {
                        return post_likes.filter(
                            (item) => item.username !== user.username
                        );
                    });
                } else {
                    // add like to post
                    setPost_likes([
                        ...post_likes,
                        {
                            first_name: user.firstname,
                            last_name: user.lastname,
                            username: user.username,
                        },
                    ]);
                }
            }
        } catch (err) {
            console.log('error');
        }
    };
    // handles commenting on a post
    const commentPost = async () => {
        if (comment !== '') {
            try {
                const requestBody = {
                    content: comment,
                    post: props.postContent.pk,
                };
                let response = await axios.post(
                    '/api/social/comment/',
                    JSON.stringify(requestBody),
                    {
                        headers: {
                            'Content-Type': 'application/json',
                        },
                        withCredentials: true,
                    }
                );
                if (response.status === 200) {
                    setComment('');
                    setShowCommentField(!showCommentField);
                    setPostComments([
                        ...postComments,
                        {
                            commenter: {
                                first_name: user.firstname,
                                last_name: user.lastname,
                            },
                            comment: comment,
                            comment_date: 'just now',
                        },
                    ]);
                }
            } catch (err) {}
        }
    };

    return (
        <div className="feed-post">
            <div className="feed-post-content">
                <div className="feed-post-content-creator">
                    <h3>
                        <Link to={'/profile/' + postContent.creator.username}>
                            {postContent.creator.first_name}{' '}
                            {postContent.creator.last_name}
                        </Link>
                    </h3>
                    <p className="feed-post-content-creator-dateTime">
                        {format(new Date(postContent.created), 'PPPPpp')}
                    </p>
                </div>
                <div className="feed-post-content-icons">
                    <div className="feed-post-content-icons-instance">
                        <button onClick={likePost} className="btn icon-button">
                            <i className="bi bi-hand-thumbs-up-fill bi-icon-lg"></i>
                        </button>
                        <p className="feed-post-content-icons-instance-number">
                            <sup>{post_likes.length}</sup>
                        </p>
                    </div>
                </div>
            </div>
            <div className="feed-post-content">
                <p className="feed-post-content-text">{postContent.content}</p>
            </div>
            <p className="feed-post-attach">
                <button
                    className="underlined-button"
                    onClick={() => setShowComments(!showComments)}
                >
                    Comments{' '}
                </button>
                ({props.postContent.comments.length})
                <button
                    className="underlined-button"
                    onClick={() => setShowAttachments(!showAttachments)}
                >
                    Attachments{' '}
                </button>
                (0)
            </p>
            {showComments && (
                <div className="feeds-post-comment">
                    {postComments.map((comment_x) => (
                        <div className="feed-post-comment">
                            <FeedComments postComments={comment_x} />
                        </div>
                    ))}
                </div>
            )}
            {showComments ? (
                <div className="feed-post-comment-input">
                    <input
                        type="text"
                        className="field-feed-comment"
                        placeholder={`Comment here, ${user.firstname}`}
                        value={comment}
                        onChange={handleChange}
                    />
                    <button onClick={commentPost} className="btn icon-button">
                        <i class="bi bi-send-fill bi-icon-md"></i>
                    </button>
                </div>
            ) : null}
        </div>
    );
};

export default FeedPost;
